var exports = {
  "k": "x61f99309--f6b46d--container",
};

module.exports = exports;
